// =============================================================================
// VOICE WAVEFORM — Live, restrained recording visualization
//
// FOUNDER DIRECTION (December 2025):
// "Display a restrained live waveform / voice-frequency visualization
//  responding to the user's speech. Keep the waveform compact and contained
//  within the composer."
//
// Visual treatment: Arvexis style - restrained, premium, calm, minimal,
// with subtle Arvexis motion/accent treatment. Avoid generic red voice-recorder.
//
// Extracted unchanged from CompanionChat so the Message composer and the Dream
// composer share one source of truth and cannot drift apart.
// =============================================================================
import { motion } from 'framer-motion';

export const VoiceWaveform = ({ audioLevel = 0, isActive = false }) => {
  // Compact waveform - fewer bars for cleaner look
  const barCount = 16;
  const bars = [];

  for (let i = 0; i < barCount; i++) {
    // Create natural variation across bars
    const position = i / barCount;
    const centerDistance = Math.abs(position - 0.5) * 2;

    // Base height with center emphasis
    const baseHeight = 0.3 + (1 - centerDistance) * 0.4;

    // Audio-reactive component
    const audioComponent = isActive ? audioLevel * (0.5 + Math.random() * 0.5) : 0;

    // Final height (0.2 to 1.0)
    const height = Math.min(1, Math.max(0.2, baseHeight * 0.3 + audioComponent * 0.7));

    bars.push(
      <motion.div
        key={i}
        className="w-[2px] rounded-full"
        style={{
          background: isActive
            ? 'linear-gradient(to top, rgba(180, 140, 255, 0.7), rgba(212, 168, 67, 0.5))'
            : 'rgba(255, 255, 255, 0.15)'
        }}
        animate={{
          height: `${height * 100}%`,
          opacity: isActive ? 0.9 : 0.3
        }}
        transition={{
          height: { duration: 0.08, ease: 'easeOut' },
          opacity: { duration: 0.15 }
        }}
      />
    );
  }

  return (
    <div
      className="flex items-center justify-center gap-[3px] h-6"
      style={{ minWidth: '80px' }}
    >
      {bars}
    </div>
  );
};

export default VoiceWaveform;
